



















































import {Vue, Component, Prop} from 'vue-property-decorator';
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import * as letterService from '@/store/Services/letterServices';
import store from '@/store';
import * as $ from 'jquery';
import RecipientSelector from './RecipientSelector/RecipientSelector.vue';
import { LetterOwnerWithFaxAndEmails } from '@/store/models/LetterOwner/LetterOwnerWithFaxAndEmails';
import {LetterOwnerWithSendingInformationAndAttachments } from '@/store/models/LetterOwner/LetterOwnerWithSendingInformationAndAttachments';
import * as autoCompleteDataService from '@/store/Services/autoCompleteDataService.ts';
import { AutoCompleteData } from '@/store/models/Letter/AutoCompleteData';
import ToggleSwitch from '@/components/UiComponents/ToggleSwitch.vue';
import { LetterOwnerEmail } from '@/store/models/LetterOwner/LetterOwnerEmail';
import { Letter } from '@/store/models/Letter/Letter';
import * as util from '@/util/utils';
import RecipientLookup from './RecipientLookup/RecipientLookup.vue';
import Parts from '@/store/models/Letter/Parts';
import LetterAttachment from '@/components/Cartable/LetterDetails/LetterAttachment/LetterAttachment.vue';
import InPlaceMessageBox from '@/components/UiComponents/InPlaceMessageBox.vue';
import FullPageLoader from '@/components/UiComponents/FullPageLoader.vue';
@Component({
    components: {RecipientSelector, ToggleSwitch, RecipientLookup, LetterAttachment,InPlaceMessageBox , FullPageLoader}
})
export default class ForwardLetter extends Vue{
    recipients: LetterOwnerWithFaxAndEmails[] = [];
    selectedMainRecipients:  LetterOwnerWithSendingInformationAndAttachments [] = [];
    selectedCopyRecipients:  LetterOwnerWithSendingInformationAndAttachments [] = [];
    autoCompleteData: AutoCompleteData[] = [];
    msgBoxBtns = 'ok';
    message = '';
    messageType = '';
    shallShowMessageBox = false;
    isDone = false;
    loading = false;
    @Prop() letter?: Letter;
    get attachments(){
        
        const result: Parts[] = [];
        if(this.letter === undefined)return result;
        if(this.letter.parts === undefined || this.letter.parts === null)return result;
        for(let i = 1;i<this.letter.parts.length;i++){
            result.push(this.letter.parts[i]);
        }
        return result;
    }
    async created(){
        const ownerId = store.state.ownerId;
        let formId = "";
        if(this.letter){
            if(this.letter.isEnterpriseForm)
                formId = this.letter.enterpriseFormId;
        }
        this.recipients =   await letterOwnerService.getOwnerForwardRecipients(ownerId,formId);
        console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
        console.log(this.letter);
        console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
    }
    // async mounted(){
    //     $('#main-recipient-dropdown').dropdown({action:'hide',silent: true ,message: {noResults : 'یافت نشد'}});
    //     $('#copy-recipient-dropdown').dropdown({action:'hide',silent: true ,message: {noResults : 'یافت نشد'}});
       
    // }
    
    selectMainRecipient(recipient: LetterOwnerWithFaxAndEmails){
        this.shallShowMainLookup = false;
        let addedItem =  this.selectedMainRecipients.find(item=>item.id === recipient.id);
        if(!addedItem) 
            addedItem = this.selectedCopyRecipients.find(item=>item.id === recipient.id);
        if(!addedItem)
            this.selectedMainRecipients.push(letterOwnerService.getLetterOwnerWithSendingInfo(recipient));
    }
    onMainRecipientRemoved(id: string){
        const removedItem =  this.selectedMainRecipients.find(item=>item.id === id);
        if(!removedItem)return;
        const index =  this.selectedMainRecipients.indexOf(removedItem);
        this.selectedMainRecipients.splice(index,1);        
    }
    selectCopyRecipient(recipient: LetterOwnerWithFaxAndEmails){
        this.shallShowCopyLookup = false;
        let addedItem =  this.selectedCopyRecipients.find(item=>item.id === recipient.id);
        if(!addedItem) 
            addedItem = this.selectedMainRecipients.find(item=>item.id === recipient.id);
        if(!addedItem)
            this.selectedCopyRecipients.push(letterOwnerService.getLetterOwnerWithSendingInfo(recipient));
    }
    onCopyRecipientRemoved(id: string){
        const removedItem =  this.selectedCopyRecipients.find(item=>item.id === id);
        if(!removedItem)return;
        const index =  this.selectedCopyRecipients.indexOf(removedItem);
        this.selectedCopyRecipients.splice(index,1);        
    }
    
    async send(){
        if(this.selectedMainRecipients.length === 0 && this.selectedCopyRecipients.length === 0){
            this.messageType = 'fail';
            this.message = 'هیچ گیرنده اصلی یا رونوشت انتخاب نشده است';
            this.shallShowMessageBox = true;
            return;
        }
        this.selectedMainRecipients.forEach(recipient=>{
            const emailsToRemove = [] as LetterOwnerEmail[];
            for(let i = 0;i<recipient.emails.length; i++ ){
                if(!recipient.emails[i].canBeUsedForSending)
                    emailsToRemove.push(recipient.emails[i]);
            }
            emailsToRemove.forEach(removingEmail=>{
                const index =  recipient.emails.indexOf(removingEmail);
                recipient.emails.splice(index,1);
            });
            recipient.attachments.forEach(file=>{
                file.content = util.base64RemovePrefix(file.content);
            });   
        });
        this.selectedCopyRecipients.forEach(recipient=>{
            const emailsToRemove = [] as LetterOwnerEmail[];
            for(let i = 0;i<recipient.emails.length; i++ ){
                if(!recipient.emails[i].canBeUsedForSending)
                    emailsToRemove.push(recipient.emails[i]);
            }
            emailsToRemove.forEach(removingEmail=>{
                const index =  recipient.emails.indexOf(removingEmail);
                recipient.emails.splice(index,1);
            });   
        });
        if(!this.letter)return;
        this.loading = true;
        const result = await letterService.ForwardLetter(this.letter.letterPossessionId,this.selectedMainRecipients,this.selectedCopyRecipients)
        this.loading = false;
        if(result != null){
            
            //this.message = "ارجاع انجام شد";
            //this.messageType = 'success';
            //this.shallShowMessageBox = true;
            this.isDone = true;
            this.$emit("forward-done",this.letter.letterPossessionId);
            store.state.eventHub.$emit("show-message","ارجاع انجام شد");
            store.state.eventHub.$emit('calc-letterscount-requested');
            this.close();
        }
        
    }

    close(){
        this.$emit("forward-closed");
    }
    onMessageBoxBtnClicked(btn: string){
        this.shallShowMessageBox = false;
    }
    shallShowMainLookup = false;
    shallShowCopyLookup = false;
    onAddRecipientRequest(mode: string){
        switch(mode){
            case 'main':
                this.shallShowMainLookup = true;
                break;
            case 'copy':
                this.shallShowCopyLookup = true;
                break;
        }
    }
}
